export default __webpack_public_path__ + "assets/klix_logo-50f0d74537256744e15ea3cbe3b1cf0e.png";